import React, { useState, useEffect } from "react";
// styled components
import { Row, Col, Table, Modal, Empty, Button, Checkbox, Tabs } from "antd";
// models
import { PostulacionModel } from "../../../../../models/PostulacionesModel/postulacion.model";
// icons
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
// components
import { InformacionPostulacion } from "./InformacionPostulacion";
import { ParticipantesPostulacion } from "./ParticipantesPostulacion";
import { spawn } from "child_process";
import getStorageUser from "../../../../../middlewares/GetStorageUser"
import { FormularioInscripcion } from "./FormularioInscripcion";
import apiDocumentos from "../../../../../api/Documentos/api-documentos";
import JSZip from 'jszip';

interface IProps {
  modal: boolean;
  AceptarModal: any;
  CancelarModal: any;
  postulacion: PostulacionModel;
  descargarArchivo: any;
  setAllPostulaciones: any;
  allpostulaciones: any;
  isBeps?: boolean;
  lineasConvocatoria: any;
  setCountSubsanable?: any;
  countSubsanable?: any;
  setIdPostulacion?: any;
  idPostulacion?: any;
  setObservaciones?: any;
  observaciones?: any;
}

export const ModalVerPropuesta: React.FC<IProps> = (props: IProps) => {
  const [user, setUser] = useState<any>({});

  const getUser = async () => {
    try {
      const _user = getStorageUser()
      setUser(_user)
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUser();
  }, [])

  const descargar = async () => {
    const zip = new JSZip();
    try {
      if (props.postulacion.documentos_administrativos) {
        await Promise.all(
          props.postulacion.documentos_administrativos.map(async (documento, index) => {
            try {
              const response = await apiDocumentos.consultarArchivo(documento.url_participante);
              if (response && response.data != null && response.data !== '') {
                zip.file(`${props.postulacion.radicado}_${documento.descripcion}.pdf`, response.data);
              }
            } catch (error) {
              console.error(`Error al descargar el documento administrativo ${index + 1}:`, error);
            }
          })
        );
      }
      if (props.postulacion.documentos_tecnicos) {
        await Promise.all(
          props.postulacion.documentos_tecnicos.map(async (documento, index) => {
            try {
              const response = await apiDocumentos.consultarArchivo(documento.url_participante);
              if (response && response.data != null && response.data !== '') {
                zip.file(`${props.postulacion.radicado}_${documento.tipo_documento}.pdf`, response.data);
              }
            } catch (error) {
              console.error(`Error al descargar el documento de educación formal ${index + 1}:`, error);
            }
          })
        );
      }

      zip.generateAsync({ type: 'blob' }).then((content) => {
        const url = window.URL.createObjectURL(content);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${props.postulacion.radicado}_${props.postulacion.nombre_propuesta}`
        a.click();
        window.URL.revokeObjectURL(url);
        //setEstado('Archivos descargados correctamente');
      });
    } catch (error) {
      console.error('Error general al descargar los archivos:', error);
      //setEstado('Error al descargar los archivos');
    }
  };

  // pagination table
  function itemRenderTable(current: any, type: any, originalElement: any) {
    if (type === "prev") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          <LeftOutlined className="font-color-051923bf" style={{ display: "inline-flex", paddingRight: "2px" }} />
          Ant.
        </span>
      );
    }
    if (type === "next") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          Sig.
          <RightOutlined className="font-color-051923bf" style={{ display: "inline-flex", paddingLeft: "2px" }} />
        </span>
      );
    }
    return originalElement;
  }


  return (
    <>
      <Modal
        className="ant-modal-close-x2"
        title={
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <div>
              {`${props.postulacion.nombre_propuesta}`}
            </div>
            <div style={{ marginRight: '35px' }}>
              {`Código: ${props.postulacion.radicado}`}
            </div>
          </div>
        }
        style={{ top: 50 }}
        visible={props.modal}
        onCancel={props.CancelarModal}
        afterClose={() => {
          props.setCountSubsanable(0);
        }}
        closeIcon="X"
        width={1400}
        footer={[
          <Button key="b_cancelar_modal_ver_prop1" className="button-gray-ghost" onClick={props.CancelarModal}>
            Cancelar
          </Button>,
          <Button className="button-gray-ghost order-0" onClick={descargar}>
              Descargar zip
          </Button>,
          user.documento != '43188189' ?
            <Button key="b_aceptar_modal_ver_prop1" className="button-azul-radius" onClick={() => {
              props.AceptarModal(props.observaciones, props.countSubsanable, props.setObservaciones)
            }}>
              Guardar propuesta
            </Button>
          : <span></span>
        ]}
        bodyStyle={{
          padding: 0,
        }}
        maskStyle={{
          backgroundColor: "rgba(31,174,239,0.8)",
          borderRadius: "6px",
        }}
      >
        <Tabs defaultActiveKey="1" className="height-100 width-100 tabs-modal-postulaciones">
          <Tabs.TabPane tab="Información" key="1" className="height-100 font-size-14px font-family-Montserrat-Regular">
            <InformacionPostulacion
              postulacion={props.postulacion}
              setAllPostulaciones={props.setAllPostulaciones}
              allpostulaciones={props.allpostulaciones}
              descargarArchivo={props.descargarArchivo}
              isBeps={props.isBeps}
              lineasConvocatoria={props.lineasConvocatoria}
              setCountSubsanable={props.setCountSubsanable}
              countSubsanable={props.countSubsanable}
              setIdPostulacion={props.setIdPostulacion}
              idPostulacion={props.idPostulacion}
              setObservaciones={props.setObservaciones}
              observaciones={props.observaciones}
            />
          </Tabs.TabPane>
          {props.isBeps ? null :
            <Tabs.TabPane
              tab="Participantes"
              key="2"
              className="height-100 font-size-14px font-family-Montserrat-Regular"
            >
              <ParticipantesPostulacion postulacion={props.postulacion} />
            </Tabs.TabPane>
          }
          <Tabs.TabPane
            tab="Formulario de inscripción"
            key="3"
            className="height-100 font-size-14px font-family-Montserrat-Regular"
          >
            <FormularioInscripcion postulacion={props.postulacion} lineasConvocatoria={props.lineasConvocatoria} />
          </Tabs.TabPane>
        </Tabs>
      </Modal>
    </>
  );
};
